import { Injectable } from '@angular/core';
import { endBefore, Firestore, getDoc, orderBy, startAt,doc, QueryConstraint, serverTimestamp, setDoc, where } from '@angular/fire/firestore';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class UserSettingsService {
  filterData: any;

  constructor(
    private userService: UserService,
    private firestore: Firestore
  ) { }

  async getQuery(query:any) {
    let userQuery:QueryConstraint[] = []
    let userContentRef = this.userService.getUserContentRef()
    this.filterData = await this.getfilterData()
    //show mine filter
    if (this.filterData['lpgShowMine'] == true)
      userQuery.push(where('createdBy', '==', userContentRef.refUserId))
    else
      userQuery.push(where('refAccountId', '==', userContentRef.refAccountId))

    // start at date filter
    if(this.filterData['lpgShowFrDt'])
      userQuery.push(where('creationDate', '>=', this.filterData['lpgShowFrDt']))
    // endbefore date filter
    if(this.filterData['lpgShowToDt'])
      userQuery.push(where('creationDate', '<=', this.filterData['lpgShowToDt']))
    // append all query
    userQuery =[...userQuery,...query]
    return userQuery
  }

  // save the filter data
  saveFilter(filterData: any) {
    return new Promise((resolve, reject) => {
      filterData['lpgFilterDt'] = serverTimestamp();
      let userContentRef = this.userService.getUserContentRef();
      if (userContentRef.refUserId) {
        let userSettingRef = doc(this.firestore, 'user', userContentRef.refUserId, 'userSettings', userContentRef.refUserId);
        setDoc(userSettingRef, filterData, { merge: true }).then((result) => {
          resolve(filterData);
        }).catch((err) => {
          reject(err);
        });
      } else {
        reject(null)
      }
    })
  }
  // get filter data for current logged in user
  getfilterData() {
    return new Promise((resolve, reject) => {
      let userContentRef = this.userService.getUserContentRef();
      if (userContentRef?.refUserId) {
        let userSettingRef = doc(this.firestore, 'user', userContentRef.refUserId, 'userSettings', userContentRef.refUserId);
        let filter: any = null;
        getDoc(userSettingRef).then((doc) => {
          filter = doc.data();
          if(!filter)
            filter = {}
          resolve(filter)
        }).catch((err) => {
           resolve({})
          });
      }
      else
      resolve({})
    })
  }
}
